import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UserService from "../../services/UserService";
import AuthService from "../../services/AuthService";
import Swal from "sweetalert2";
import i18next from "i18next";
import { toast } from "react-toastify";

export const login = createAsyncThunk("user/login", async (data) => {
  try {
    const res = await AuthService.login(data);

    if (res && res?.status == 1) {
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("email", res.data.email);
      localStorage.setItem("name", res.data.name);
      localStorage.setItem("userType", res.data.user_type);
      localStorage.setItem("userId", res.data.id);

      return res.data;
    }
  } catch (error) {
    console.log(error);
  }
});

export const fetchAuthUser = createAsyncThunk(
  "user/fetchAuthUser",
  async () => {
    try {
      const res = await UserService.getAuthUser();
      if (res && res?.status == 1) {
        return res.data;
      } else if (res?.status == 2) {
        toast.error(i18next.t("We couldn’t find your account info. Contact the administrator."));
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("userType");
        setTimeout(() => {
          window.location.href = "login";
        }, 2000);
      } else {
        return res.data
      }

    } catch (error) {
      console.log(error);
    }
  }
);

export const editUserMerchantProfile = createAsyncThunk(
  "user/editUserMerchantProfile",
  async (data,thunkAPI) => {
    try {
      const res = await UserService.updateUserMerchantProfile(data);
      thunkAPI.dispatch(fetchAuthUser());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const editUserBranchProfile = createAsyncThunk(
  "user/editUserBranchProfile",
  async (data,thunkAPI) => {
    try {
      const res = await UserService.updateUserBranchProfile(data);
      thunkAPI.dispatch(fetchAuthUser());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const sendNotification = createAsyncThunk(
  "user/sendNotification",
  async (data) => {
    try {
      const res = await UserService.merchantSendNotification(data);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchNotificationStatistics = createAsyncThunk(
  "user/fetchNotificationStatistics",
  async (data) => {
    try {
      const res = await UserService.getNotificationStatistics(data);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchAllNotification = createAsyncThunk(
  "user/fetchAllNotification",
  async (data) => {
    try {
      const res = await UserService.getAllNotification();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  authUser: null,
  notification: null,
  notifications: [],
  notificationsStatistics: [],
  total_pages: 0,
  total_records: 0,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //Get CATEGORIES
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.authUser = payload;
      })
      .addCase(login.rejected, (state) => {
        state.loading = false;
      });

    //Get LOGIN USER
    builder
      .addCase(fetchAuthUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAuthUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.authUser = payload;
      })
      .addCase(fetchAuthUser.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(editUserMerchantProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUserMerchantProfile.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.authUser = payload;
      })
      .addCase(editUserMerchantProfile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(editUserBranchProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUserBranchProfile.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.authUser = payload;
      })
      .addCase(editUserBranchProfile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(sendNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendNotification.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notification = payload;
      })
      .addCase(sendNotification.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(fetchAllNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllNotification.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notifications = payload?.data.filter(item => item.is_read == 0);
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchAllNotification.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(fetchNotificationStatistics.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotificationStatistics.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.notificationsStatistics = payload?.data;
      })
      .addCase(fetchNotificationStatistics.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default userSlice.reducer;
